module.exports = __webpack_public_path__ + "static/media/head_phone.2460fe34.svg";